import Component from '@glimmer/component';
import { CoreLayoutMain } from 'core/components';
import Container from 'hcp/components/page/hvns/detail/container';

/**
 *
 * `model` is an object with an HVN `network` key and a `dependencies` key.
 * @argument model;
 * @type {Object}
 *
 */
/**
 *
 * `PageHvnsDetail` renders the HashiCorp Virtual Networks Detail page.
 *
 *
 * ```
 * <Page::Hvns::Detail
 *   @model={{@model}}
 * />
 * ```
 *
 * @class PageHvnsDetail
 *
 */
export default class PageHvnsDetail extends Component {
  <template>
    <Container @model={{@model}} as |HC|>
      <CoreLayoutMain>
        <:header>
          <HC.Header />
        </:header>
        <:body>
          <HC.View />
        </:body>
      </CoreLayoutMain>
    </Container>
  </template>
}
